import { render } from "./ItemCardSpotlightView.vue?vue&type=template&id=8990097e&scoped=true&ts=true"
import script from "./ItemCardSpotlightView.vue?vue&type=script&lang=ts"
export * from "./ItemCardSpotlightView.vue?vue&type=script&lang=ts"

import "./ItemCardSpotlightView.vue?vue&type=style&index=0&id=8990097e&lang=scss&scoped=true"
import "./ItemCardSpotlightView.vue?vue&type=style&index=1&id=8990097e&lang=scss"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8990097e"]])

export default __exports__